<template>
  <el-card
    class="model-tree p-10px absolute w-368px right-35px top-50px z-99 color-white !border-none !bg-[#2e6bb080]"
  >
    <div slot="header">
      <div class="flex justify-between items-center mb-10px">
        <span class="text-14px">模型树</span>
        <span class="text-14px el-icon-close" @click="$emit('closeComponents')"></span>
      </div>
    </div>
    <div class="h-38px p-5px">
      <el-input
        size="small"
        placeholder="请输入要过滤的设备"
        v-model="filterTreeKeyWords"
        @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
        clearable
      >
        <span
          slot="append"
          class="p-10px el-icon-arrow-down cursor-pointer"
          @click="filterModelTree(0, true, filterTreeKeyWords, 0)"
        ></span>
      </el-input>
    </div>
    <div class="w-full h-full mt-5px">
      <el-tree
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        show-checkbox
        :default-checked-keys="modelTreeProp.defaultCheckedKey"
        :default-expanded-keys="defaultExpandedKeys"
        :filter-node-method="filterNode"
        :expand-on-click-node="false"
        @node-click="clickModelTree"
        @check="checkModelTree"
        node-key="node"
      ></el-tree>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'ModelTree',
  props: {
    player: {
      type: Object,
      default: null,
    },
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
        }
      },
    },
  },
  watch: {
    'modelTreeProp.defaultCheckedKey': {
      handler(val) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(val)
          }
        })
      },
      immediate: true,
    },
    'modelTreeProp.currentNodeName': {
      handler(val) {
        if (val) {
          if (this.currentNodeName === val) return
          this.currentNodeName = val
          this.filterModelTree(0, true, val, 3)
        }
      },
    },
  },
  mounted() {
    if (this.modelTreeProp.currentNodeName) {
      // 页面初始化时不定位模型
      this.filterModelTree(0, true, this.modelTreeProp.currentNodeName, 0, false)
    }
  },
  data() {
    return {
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      defaultExpandedKeys: [], // 展开节点
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
    }
  },
  methods: {
    // 模型树点击操作
    clickModelTree(data, node, doLocation) {
      if (data.isVirtual) {
        return
      }
      if (node && node.checked && doLocation) {
        this.$emit('doLocation', data, 'modelTree')
        this.multipleLocations(data)
        this.modelTreeProp.currentNodeItem = data && data.node ? data.node : 0 // 储存选中节点的item
      }
      this.locationNode(data.node)
    },
    async multipleLocations(data, isSelect = true, isLoadEngine) {
      // 高亮选中的模型
      if (isSelect) {
        const selectNodes = await this.player.Native.Node.getSeletedNodes()
        await this.player.Native.Node.unSelectNodes(selectNodes)
        this.player.Native.Node.selectNodes([data.node])
      }
      this.player.Native.Camera.moveToNode(data.node, 2, 5)
    },
    // 模型树加载
    // eslint-disable-next-line consistent-return
    async loadNode(node, resolve) {
      let tempFilterKeys = _.filter(this.modelTreeProp.treeData, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.node
        })
        return resolve(this.modelTreeProp.treeData)
      }
      let res = []
      if (node.data.isVirtual) {
        res = node.data.childs
      } else {
        const result = await this.player.Native.Node.getProperty(node.data.node, ['children'])
        res = result?.children || []
      }
      if (res.length > 1000) {
        const shardingRes = []
        for (let i = 0; i < _.ceil(res.length / 1000); i += 1) {
          shardingRes.push({
            name: `${i * 1000 + 1}~${(i + 1) * 1000}`,
            checked: true,
            code: `${node.data.code}${i}`,
            node: `${node.data.node}${i}`,
            parentNode: node.data.node,
            visible: true,
            childs: res.slice(i * 1000, (i + 1) * 1000),
            isVirtual: true,
          })
        }
        res = shardingRes
      }
      const filterRes = _.filter(res, (el) => {
        return el?.name
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.node
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.name
        }),
        (res5) => {
          return res5.node
        }
      )
      // 查看当前节点是否没有在隐藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = (nodeObj) => {
        return (
          _.indexOf(
            _.map(_this.modelTreeProp.modelHideList, (res1) => {
              return res1.node
            }),
            nodeObj.data.node
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在隐藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在隐藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在隐藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在隐藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else if (_.some(filterRes, { checked: false })) {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          this.modelTreeProp.defaultCheckedKey = [
            ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
              return val !== node.data.node
            }),
            ...checkedKeys,
          ]
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.node) {
          if (el.node === this.currentNode.node) {
            this.locationNode(this.currentNode.node)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    locationNode(id) {
      setTimeout(() => {
        this.$refs.modelTree.setCurrentKey(id)
      }, 800)
      setTimeout(() => {
        const currentNode = document.getElementsByClassName('is-current')[0]
        currentNode?.scrollIntoView({
          block: 'center',
        })
      }, 1500)
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      const isChecked = _.includes(checkeds.checkedKeys, data.node)
      if (data.isVirtual) {
        this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
        return
      }
      this.$emit('setModelVisible', 'checkModelTree', isChecked, [data.node], checkeds)
    },
    async filterModelTree(startNode, direction, KeyWords, type, doLocation = true) {
      // 过滤模型树
      const res = await this.player.Native.Node.findNode(startNode, {
        names: [KeyWords],
        codes: [KeyWords],
      })
      // eslint-disable-next-line no-nested-ternary
      this.currentNode = res.codes
        ? res.codes[KeyWords] || {}
        : res.names ? res.names[KeyWords] || {} : {}
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode, doLocation)
      } else {
        // 未找到
        this.$message({
          showClose: true,
          message: '搜索结果到底了',
          type: 'error',
        })
      }
    },
    // 展开节点树
    async expendNode(node, doLocation) {
      const rootNode = await this.player.Native.Node.getRoot()
      const rootChild = await this.player.Native.Node.getProperty(rootNode, ['children'])
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      if (node.node === rootChild.children[0]?.node) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          this.clickModelTree(this.currentNode, { checked: true }, doLocation)
          this.locationNode(this.currentNode.node)
        })
      } else {
        const res = await this.player.Native.Node.getProperty(node.node, ['parent'])
        const currentLevelNodes = await this.player.Native.Node.getProperty(res.parent, [
          'children',
        ])
        const parentInfo = await this.player.Native.Node.getProperty(res.parent, ['code', 'name'])
        let expandIndex = null
        if (currentLevelNodes.children?.length > 1000) {
          expandIndex = _.findIndex(currentLevelNodes.children, ['node', node.node])
        }
        await this.expendNode(parentInfo, doLocation)
        if (!this.defaultExpandedKeys.includes(parentInfo.node)) {
          // 展开
          this.defaultExpandedKeys.push(parentInfo.node)
        }
        if (!_.isNil(expandIndex) && expandIndex > -1) {
          this.defaultExpandedKeys.push(
            `${parentInfo.node}${
              expandIndex % 1000 === 0 ? expandIndex / 1000 : _.ceil(expandIndex / 1000) - 1
            }`
          )
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      const rootNode = await this.player.Native.Node.getRoot()
      const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
      this.modelTreeProp.treeData = currentProperty.children
      this.modelTreeProp.modelTreeLoadEnd = true
    },
  },
  created() {
    this.getModelTreeDatas()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  background: none !important;
  border: none !important;
  &__header {
    border-bottom: none;
    color: #fff;
    padding: 0px !important;
    background: none !important;
  }
  &__body {
    padding: 0 !important;
    height: calc(100% - 25px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}
::v-deep .el-input {
  &-group__append {
    background: rgba(24, 41, 72, 0.5) !important;
    border: none !important;
    color: #fff;
    padding: 0px !important;
  }
  &__inner {
    font-size: 12px;
    border-radius: 0px;
    background-color: rgba(24, 41, 72, 0.5) !important;
    padding: 0 10px;
    color: #fff !important;
    border: none;
    border-radius: 2px;
  }
}
::v-deep .el-tree {
  height: calc(100vh - 350px);
  overflow-y: scroll;
  &-node__label {
    font-size: 12px;
    color: #fff;
  }
  &-node__content {
    height: 28px;
  }
  &__empty-text {
    font-size: 12px;
    color: #fff !important;
  }
  .is-current {
    .el-tree-node__children .el-tree-node__label {
      color: #fff;
    }
  }
}
::v-deep .el-tree,
::v-deep .el-tree-node:focus > .el-tree-node__content,
::v-deep .el-tree-node:focus,
::v-deep .el-tree-node__content:hover,
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: transparent;
}
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #3c96f3;
  color: #00c0ff;
}
::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(53, 52, 52, 0);
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: #2b323a;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
</style>
